module.exports = __webpack_public_path__ + "img/es_mi_videostill3.5453f342.jpg";